// extracted by mini-css-extract-plugin
module.exports = {"customItem":"styles_customItem__ZeZAa","customButton":"styles_customButton__kjurf"};